import {getUrlSearch} from '@/utils/getUrlSearch';

export const useDeviceInfo = () => {
  const searchJson: { [key: string]: string } = getUrlSearch();

  // 设备信息
  const statusBarHeight = `${(searchJson.statusBarHeight || 0)}px`;
  const did = (searchJson.did as string) || '';
  // 1-高途 6-公考 2-途途 11-高中(精品)
  const p_client = (searchJson.p_client as string) || '';
  const appVersion = (searchJson.version as string) || '';

  return {statusBarHeight, did, p_client, appVersion};
};
